// {
//   "id": 0,
//   "created": "2022-08-15T21:01:06.733Z",
//   "firstName": "string",
//   "middleName": "string",
//   "lastName": "string",
//   "address": "string",
//   "city": "string",
//   "stateProvince": "string",
//   "postalCode": "string",
//   "emailAddress": "string",
//   "telephone": "string",
//   "source": "string",
//   "ageFlag": "string",
//   "sponsorshipFlag": "string",
//   "bestContactTime": "string",
//   'bestContactMethod': "string",
//   "areasOfInterest": "string",
//   "skills": "string",
//   "resumeFileStoreId": 0,
//   "emailSentFlag": true,
//   "emailSentTimeStamp": "2022-08-15T21:01:06.733Z",
//   "availabilityDate": "2022-08-15T21:01:06.733Z",
//   "willingToRelocate": "string",
//   "terminalLeave": "string",
//   "terminalLeaveFrom": "2022-08-15T21:01:06.733Z",
//   "terminalLeaveTo": "2022-08-15T21:01:06.733Z"
//

let skillBridgeCAPFileStoreId = 0;

function convertFormToJSON(form) {
  const array = $(form).serializeArray(); // Encodes the set of form elements as an array of names and values.
  const json = {};
  $.each(array, function () {
    json[this.name] = this.value || "";
  });
  return json;
}

function getAreasOfInterest() {
  const areasOfInterest = [];
  const checks = Array.from($('input[name="areasOfInterest"]:checked'));
  checks.forEach((item, index) => {
    areasOfInterest.push(item.value);
  })
  return areasOfInterest;
}


$("#skillbridgeForm").submit(function(e) {
  e.preventDefault();
  var form = $(this);
  const data = convertFormToJSON(form);

  data.skillBridgeCAPFileStoreId = skillBridgeCAPFileStoreId;
  data.areasOfInterest = getAreasOfInterest();
  data.middleName = "";
  // data.sponsorshipFlag = "";

  console.log(data);

  $.ajax({
    type: "POST",
    url: "https://api.employeeworkplace.com/Api/SkillbridgeCandidate/Post",
    data: JSON.stringify(data),
    dataType: "json",
    contentType: "application/json",
    beforeSend: function (xhr) {
      xhr.setRequestHeader ('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
    },
    success: function(data)
    {
      $("#skillbridgeForm").replaceWith(
        `<h1 class="text-center">Your Expression of Interest has been Submitted! Thank you!</h1>`
      )
      console.log(data)
    }
  });

});

function updateTerminalLeaveForm(formField) {
  console.log(formField.value);

  const markup = ` <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label for="terminalLeaveFrom">Leave From: *</label>
                        <input type="date" class="form-control" name="terminalLeaveFrom" id="terminalLeaveFrom" aria-describedby="" required>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label for="terminalLeaveTo">Leave To: *</label>
                        <input type="date" class="form-control" name="terminalLeaveTo" id="terminalLeaveTo" aria-describedby="" required>
                      </div>
                    </div>`

  if (formField.value === "yes") {
    $('#terminalLeaveDateRange').html(markup);
  } else {
    $('#terminalLeaveDateRange').empty();
  }

}

function uploadResume() {
  const formData = new FormData();
  const file = $("#uploadInput")[0].files[0];
  formData.append("SkillBridgeResume", file, file.name);

  console.log(file);

  console.log(formData.entries());

  $.ajax({
    url: "https://api.employeeworkplace.com/Api/SkillbridgeCandidate/Resume/Post",
    type: 'post',
    data: formData,
    contentType: false,
    processData: false,
    beforeSend: function (xhr) {
      xhr.setRequestHeader ('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
    },
    success: function (response) {
      skillBridgeCAPFileStoreId = response.skillBridgeCAPFileStoreId;
      console.log(skillBridgeCAPFileStoreId);
      $("#alertContainer").html(
        ` <div class="alert alert-success">
               Resume uploaded successfully
              </div>`
      )
    },
    error: function(res) {
      $("#alertContainer").html(
        ` <div class="alert alert-danger">
                An error occurred. Please try again.
              </div>`
      )
    }
  });
}

$(document).ready(() => {
  $("#telephone").inputmask({"mask": "(999) 999-9999"});
  $("#uploadResumeBtn").click(() => {
    uploadResume();
  })
})
